import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FiTaskHelperService } from '@fi-shared/fi-task-shared/fi-task-helper.service';
import { MatTabGroup } from '@angular/material/tabs';
import { SideListOptionType } from '@fi-shared/types';
import { FiTasksViewMode } from '@fi-shared/fi-task-shared/fi-task-enums';
import { FiTaskSharedService } from '@fi-shared/fi-task-shared/fi-task-shared.service';
import { FiTaskV2SyncService } from '@fi-app/task-v2/fi-task-v2-sync.service';

@Component({
    selector: 'fi-task-list-header',
    template: `
        <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedIndexChange)="selectedIndexChange()">
            <mat-tab>
                <ng-template mat-tab-label
                    >{{ 'task.assigned_to_me' | fiAppText
                    }}<span class="tasks-badge">{{ assignedToMeTasksCount$ | async }}</span></ng-template
                >
                <ng-template matTabContent>
                    <fi-task-list
                        [tasksViewMode]="tasksViewMode"
                        [taskListFilterType]="SideListOptionType.TasksAssignedToMe"
                        (fiSwipeLeft)="onSwipeLeft()"
                        (fiSwipeRight)="onSwipeRight()"
                    >
                    </fi-task-list>
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label
                    >{{ 'task.private_tasks' | fiAppText
                    }}<span class="tasks-badge">{{ privateTasksCount$ | async }}</span></ng-template
                >
                <ng-template matTabContent>
                    <fi-task-list
                        [tasksViewMode]="tasksViewMode"
                        [taskListFilterType]="SideListOptionType.TasksPrivate"
                        (fiSwipeLeft)="onSwipeLeft()"
                        (fiSwipeRight)="onSwipeRight()"
                    >
                    </fi-task-list>
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label
                    >{{ 'task.assigned_by_me' | fiAppText
                    }}<span class="tasks-badge">{{ assignedByMeTasksCount$ | async }}</span></ng-template
                >
                <ng-template matTabContent>
                    <fi-task-list
                        [tasksViewMode]="tasksViewMode"
                        [taskListFilterType]="SideListOptionType.TasksAssignedByMe"
                        (fiSwipeLeft)="onSwipeLeft()"
                        (fiSwipeRight)="onSwipeRight()"
                    >
                    </fi-task-list>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    `,
    styleUrls: ['./task-list-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-list-header' },
    standalone: false,
})
export class TaskListHeaderComponent implements OnInit, OnChanges {
    @Input({ required: true }) tasksViewMode: FiTasksViewMode;
    @Input() selectedIndex = 0;
    @Output() onSelectedIndexChange = new EventEmitter<number>();
    @ViewChild(MatTabGroup, { static: false }) matTabGroup: MatTabGroup;
    protected readonly SideListOptionType = SideListOptionType;
    protected readonly FiTasksViewMode = FiTasksViewMode;

    constructor(
        private fiTaskService: FiTaskSharedService,
        private fiTaskHelperService: FiTaskHelperService,
        private fiTaskV2SyncService: FiTaskV2SyncService,
    ) {}

    get privateTasksCount$() {
        return this.fiTaskV2SyncService.privateTasksCount$;
    }

    get assignedToMeTasksCount$() {
        return this.fiTaskV2SyncService.assignedToMeTasksCount$;
    }

    get assignedByMeTasksCount$() {
        return this.fiTaskV2SyncService.assignedByMeTasksCount$;
    }

    ngOnInit(): void {
        this.loadTasksCountForTabs();
    }

    ngOnChanges(changes: SimpleChanges): void {}

    onSwipeLeft() {
        if (this.selectedIndex + 1 < this.getTabsCount()) {
            this.selectedIndex++;
            this.selectedIndexChange();
        }
    }

    onSwipeRight() {
        if (this.selectedIndex - 1 >= 0) {
            this.selectedIndex--;
            this.selectedIndexChange();
        }
    }

    getTabsCount() {
        return this.matTabGroup._tabs.length;
    }

    selectedIndexChange() {
        this.onSelectedIndexChange.emit(this.selectedIndex);
    }

    private loadTasksCountForTabs() {
        this.fiTaskV2SyncService.loadTasksCountForTabs(this.tasksViewMode);
    }
}
